export default function tableResponsive () {
    function isMobile() {
        return window.matchMedia("only screen and (max-width: 768px)").matches;
    }
    let tableContainers = document.getElementsByClassName('table-responsive');
    if (isMobile()) {
        Array.from(tableContainers).forEach(function (tableContainer) {
            let scrollable = tableContainer.scrollWidth > tableContainer.clientWidth;
            if (scrollable) {
                tableContainer.setAttribute('tabindex', '0');
            }
        });
    }
}